import { EVENTS } from '@archetype-themes/utils/events'
import { debounce } from '@archetype-themes/utils/utils'

class PredictiveSearch extends HTMLElement {
  constructor() {
    super()
    this.enabled = this.getAttribute('data-enabled')
    this.context = this.getAttribute('data-context')
    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector('#predictive-search')
    this.closeBtn = this.querySelector('.btn--close-search')
    this.screen = this.querySelector('[data-screen]')
    this.SearchModal = this.closest('#SearchModal') || null
    this.header_search = this.closest('header-search.js_updated_layout_searchbar')

    // listen for class change of 'modal--is-active on this.SearchModal
    if (this.SearchModal) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const modalClass = mutation.target.className
            if (modalClass.indexOf('modal--is-active') > -1) {
              setTimeout(() => {
                this.input.focus()
              }, 100)
            }
          }
        })
      })

      observer.observe(this.SearchModal, {
        attributes: true
      })
    }
  }

  connectedCallback() {
    console.log('header search init successfully');
    if (this.enabled === 'false') return

    this.abortController = new AbortController()

    // Open events
    document.addEventListener(
      EVENTS.predictiveSearchOpen,
      (e) => {
        if (e.detail.context !== this.context) return
        this.classList.add('is-active')

        // Wait for opening events to finish then apply focus
        setTimeout(() => {
          this.input.focus()
        }, 100)

        document.body.classList.add('predictive-overflow-hidden')
        this.initRecommendationSearch();
      },
      { signal: this.abortController.signal }
    )

    // Show recommendation search
    this.input.addEventListener('click', (e) => {
      if(this.header_search) this.header_search.classList.add('is-active');
      if(this.header_search) this.closeBtn.style.display = 'block';
      this.initRecommendationSearch();
    })

    // On typing
    this.input.addEventListener('keydown', () => {
      this.classList.add('is-active')
    })

    this.input.addEventListener(
      'input',
      debounce(200, (event) => {
        this.onChange(event)
      }).bind(this)
    )

    // Close events
    document.addEventListener(
      EVENTS.predictiveSearchClose,
      () => {
        this.close()
      },
      { signal: this.abortController.signal }
    )

    document.addEventListener(
      'keydown',
      (evt) => {
        if (evt.keyCode === 27) this.close()
      },
      { signal: this.abortController.signal }
    )

    this.closeBtn.addEventListener(
      'click',
      (evt) => {
        evt.preventDefault()
        if(this.input.value.length > 0) {
          this.input.value = '';
          this.onChange();
        } else{
          this.close()
          if(this.header_search) this.closeBtn.style.display = 'none';
        }
      },
      { signal: this.abortController.signal }
    )

    this.screen?.addEventListener(
      'click',
      () => {
        this.close()
      },
      { signal: this.abortController.signal }
    )

    document.addEventListener(EVENTS.headerSearchClose, () => {
      this.close()
    })
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  initRecommendationSearch() {
    // console.log('recommendationSearch function called...');
    const recommendationSearchWrappers = this.querySelectorAll('.js_search_recommendation_wrapper');
    if(recommendationSearchWrappers.length > 0) {
      recommendationSearchWrappers.forEach(recommendationSearchWrapper => {
        const allJSTitles = recommendationSearchWrapper.querySelectorAll('.js_search_recommendation_title');
        if(allJSTitles.length > 0) {
          allJSTitles.forEach(ele => {
            ele.addEventListener('click', () => {
              allJSTitles.forEach(ele => {
                ele.classList.remove('selected');
              });
              ele.classList.add('selected');

              if(ele.dataset.target === 'results') {
                const main_result = recommendationSearchWrapper.querySelector('#predictive-search-products');
                if(main_result) {
                  main_result.removeAttribute('hidden');
                  main_result.style.display = '';
                }
              }else{
                const main_result = recommendationSearchWrapper.querySelector('#predictive-search-products');
                if(main_result) {
                  main_result.setAttribute('hidden', true);
                  main_result.style.display = 'none';
                }
              }

              const relatedAllGrids = recommendationSearchWrapper.querySelectorAll('.js_custom_recommended_grid_wrapper');              
              if(relatedAllGrids.length > 0) {
                relatedAllGrids.forEach(grid => {
                  const relatedDataTarget = grid.dataset.relatedTarget;
                  if(relatedDataTarget === ele.dataset.target) {
                    grid.removeAttribute('hidden');
                  } else {
                    grid.setAttribute('hidden', true);
                  }
                })
              }
              const allCollectionLink = recommendationSearchWrapper.querySelector('.all_collection_link');
              if(allCollectionLink) {
                allCollectionLink.href = ele.dataset.url;
              }
            })
          })
        }
      })
    }
  }
  updateRecommendationSearch(searchTerm){
    const recommendationSearchWrapper = this.querySelector('.js_search_recommendation_main_wrapper')?.querySelector('.predictive-search-wrap');
    const SearchResultWithRecommendation = this.querySelector('.header_predictive_search_with_results.search__results.has_search_recommendation');
    if(searchTerm.length > 0) {
      this.predictiveSearchResults.style.cssText = '';
      recommendationSearchWrapper.style.display = 'none';
      if(SearchResultWithRecommendation) SearchResultWithRecommendation.style.overflowY = 'unset';
    }else{
      this.predictiveSearchResults.style.display = 'none';
      recommendationSearchWrapper.style.display = '';
      if(SearchResultWithRecommendation) SearchResultWithRecommendation.style.overflowY = 'auto';
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length){
      this.updateRecommendationSearch(searchTerm);
      return
    }

    this.getSearchResults(searchTerm)
  }

  getSearchResults(searchTerm) {
    const searchObj = {
      q: searchTerm,
      'resources[limit]': 10,
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,variants.sku,product_type,variants.title,variants.barcode'
    }

    const params = this.paramUrl(searchObj)

    fetch(`${window.Shopify.routes.root}search/suggest?${params}&section_id=search-results`)
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-results').innerHTML
        this.predictiveSearchResults.innerHTML = resultsMarkup
        this.updateRecommendationSearch(searchTerm);
        this.initRecommendationSearch();
        this.open()
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  open() {
    this.predictiveSearchResults.style.display = 'block'
  }

  close() {
    this.predictiveSearchResults.style.display = 'none'
    this.predictiveSearchResults.innerHTML = ''
    this.classList.remove('is-active')
    document.body.classList.remove('predictive-overflow-hidden')
    if (this.contains(document.activeElement)) document.activeElement.blur()
    if(this.header_search && this.input.value.length < 1) this.header_search.classList.remove('is-active');

    /**
     * @event predictive-search:close-all
     * @description Fired when the predictive search is closed.
     */
    this.dispatchEvent(new CustomEvent(EVENTS.predictiveSearchCloseAll, { bubbles: true }))
  }

  paramUrl(obj) {
    return Object.keys(obj)
      .map(function (key) {
        return key + '=' + encodeURIComponent(obj[key])
      })
      .join('&')
  }
}

customElements.define('predictive-search', PredictiveSearch)
